import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { ref, set } from "firebase/database";
import { doc, getDoc, setDoc } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { useUser } from "../contexts/UserContext";
import { auth, db, rtdb } from "../firebaseConfig";
import { GoogleIcon } from "./GoogleIcon";
import { VoiceVisualization } from "./VoiceViz";

const Auth = () => {
	const { setUser, setEncryptionKey } = useUser();
	const [showError, setShowError] = useState(false);
	const [error, setError] = useState("");
	const [setSessionId] = useState(null);

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const sid = urlParams.get("session_id");
		if (sid) {
			setSessionId(sid);
			localStorage.setItem("pending_session_id", sid);
		}
	}, []);

	const generateEncryptionKey = () => {
		const array = new Uint8Array(32);
		window.crypto.getRandomValues(array);
		return Array.from(array, (byte) =>
			byte.toString(16).padStart(2, "0")
		).join("");
	};

	const signInWithGoogle = async () => {
		try {
			const provider = new GoogleAuthProvider();
			const result = await signInWithPopup(auth, provider);
			const user = result.user;

			const userRef = doc(db, "Users", user.uid);
			const userSnap = await getDoc(userRef);

			if (!userSnap.exists()) {
				console.log("Creating new user document for:", user.uid);
				const encryptionKey = generateEncryptionKey();
				await set(ref(rtdb, `encryption_keys/${user.uid}`), {
					key: encryptionKey,
				});
				await setEncryptionKey(encryptionKey);

				await setDoc(userRef, {
					email: user.email,
					name: user.displayName,
					createdAt: new Date(),
				});
			}

			setUser(user);
		} catch (error) {
			console.error("Error signing in with Google:", error);
			setError(error.message);
			setShowError(true);
		}
	};

	return (
		<div className="flex items-center justify-center min-h-screen bg-gray-100 p-4">
			<div className="w-full max-w-md backdrop-blur-lg rounded-3xl shadow-xl overflow-hidden flex flex-col bg-gray-100 bg-opacity-30">
				{" "}
				<div className="w-full text-center p-4">
					<h1 className="text-2xl sm:text-3xl font-thin text-blue-900 tracking-wide m-2 sm:m-3">
						Hey
						<span className="font-normal text-blue-800">
							Akua
						</span>{" "}
					</h1>
					<div className="flex justify-center mt-0 mb-5">
						<div className="w-1/2">
							<VoiceVisualization isActive={true} />
						</div>
					</div>
					<div className="flex justify-center">
						<button
							className="flex items-center justify-center gap-2 px-2 py-2 rounded-lg border border-blue-900 shadow-md hover:bg-blue-100 text-blue-900 cursor-pointer m-4 transition-colors duration-300 sm:px-4 sm:py-4 sm:m-5"
							onClick={signInWithGoogle}>
							<GoogleIcon className="ml-2 mr-1" />
							Sign in with Google to talk to Akua!
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Auth;
